module.exports = __webpack_public_path__ + "media/images/support_ticket_icon-e354746fcf8690b919a0bbe36734f0a7.svg";